import React, { Component } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";

import AgentVenueTable from "../../components/agent/venueRoster/AgentVenueTable";
import SentRequestsTable from "../../components/agent/venueRoster/SentRequestsTable";
import IncomingRequestsTable from "../../components/agent/venueRoster/IncomingRequestsTable";
import VenueInvitationModal from "../../components/agent/venueRoster/VenueInvitationModal";
import Heading from "../../components/Heading";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { Tabs, Tab, Badge, Button, Paper, AppBar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ProfileRelationType } from "../../types/enum";

import "./AgentVenue.css";

const styles = theme => ({
    tabBadge: {
        padding: "0 8px"
    },
    badge: {
        top: "50%",
        right: -16,
        backgroundColor: "#ff9800",
        color: "white"
    },
    badgeHighlight: {
        top: "50%",
        right: -16,
        backgroundColor: "#f44336",
        color: "white",
        animation: "pulse 2s infinite"
    }
});

@inject("venueActStore", "agentVenueStore", "userInvitationStore", "profileStore", "templateStore")
@withRouter
@observer
class AgentVenue extends Component {
    state = {
        tabValue: 0,
        venueInvitationModalState: false
    };

    componentDidMount() {
        this.props.venueActStore.resetList();
        this.props.agentVenueStore.resetData();
        this.props.userInvitationStore.resetInvitations();
        
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        this.props.profileStore.loadProfiles().then(() => {
            if (currentProfile?.isConsultant) {
                Promise.all([
                    this.props.agentVenueStore.getAgentVenueRequest(),
                    this.props.agentVenueStore.getConsultantVenueRosterV2(currentProfile?.id, 20, 1),
                    this.props.userInvitationStore.getMyUserInvitation(ProfileRelationType.AgentVenue.ordinal, currentProfile?.id)
                ]).then(() => {
                    this.props.templateStore.hideLoadingScreen();
                });
            } else {
                Promise.all([
                    this.props.agentVenueStore.getAgentVenueRequest(),
                    this.props.agentVenueStore.getMyVenueRosterV2(currentProfile?.id, 20, 1),
                    this.props.userInvitationStore.getMyUserInvitation(ProfileRelationType.AgentVenue.ordinal, currentProfile?.id)
                ]).then(() => {
                    this.props.templateStore.hideLoadingScreen();
                });
            }
        });
    }

    createBooking = (venueId) => {
        let redirectUrl = `/booking/new?actId=undefined&venueId=${venueId}&dateStart=${moment(new Date()).format("DD-MM-YYYY")}`;
        this.props.history.push(redirectUrl);
    }

    redirectVenueFavourite = (data) => {
        let redirectUrl = `/agent/actfavorite/venues/${data.venueId}/${data.venue.fullName}`;
        this.props.history.push(redirectUrl);
    }

    handleTabChange = (event, value) => {
        this.setState({ tabValue: value });
    };

    openInvitationModal = () => {
        this.props.agentVenueStore.resetInvitationField();
        this.setState({ venueInvitationModalState: true });
    };

    closeInvitationModal = () => {
        this.setState({ venueInvitationModalState: false });
    };

    getSentRequestsCount = () => {
        const { invitations } = this.props.userInvitationStore;
        const { pendingAgentVenues } = this.props.agentVenueStore;
        
        const processedVenueIds = new Set();
        const processedVenueNames = new Set();
        let count = 0;
        
        if (pendingAgentVenues && pendingAgentVenues.length > 0) {
            pendingAgentVenues.forEach(p => {
                if (p && p.primaryProfile?.type === 2) {
                    const venue = p.primaryProfile?.type === 3 ? p.primaryProfile : p.secondaryProfile;
                    if (venue?.id) {
                        processedVenueIds.add(String(venue.id));
                    }
                    if (venue?.fullName) {
                        processedVenueNames.add(venue.fullName.toLowerCase().trim());
                    }
                    count++;
                }
            });
        }
        
        if (invitations && invitations.length > 0) {
            invitations.forEach(inv => {
                if (!inv) return;
                
                if (inv.invitedProfileId && processedVenueIds.has(String(inv.invitedProfileId))) {
                    return;
                }
                
                if (inv.invitedVenue && processedVenueNames.has(inv.invitedVenue.toLowerCase().trim())) {
                    return;
                }
                
                count++;
            });
        }
        
        return count;
    };

    getIncomingRequestsCount = () => {
        const { pendingAgentVenues } = this.props.agentVenueStore;
        return pendingAgentVenues?.filter(p => 
            p.primaryProfile?.type !== 2
        ).length || 0;
    };

    renderTabComponent = () => {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return (
                    <AgentVenueTable 
                        redirectVenueFavourite={(data) => this.redirectVenueFavourite(data)} 
                        createBooking={(venueId) => this.createBooking(venueId)}
                    />
                );
            case 1:
                return <SentRequestsTable />;
            case 2:
                return <IncomingRequestsTable />;
            default:
                return null;
        }
    };

    render() {
        const { classes } = this.props;
        const sentRequestsCount = this.getSentRequestsCount();
        const incomingRequestsCount = this.getIncomingRequestsCount();

        return (
            <div>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="My Venue Roster">
                        <Button 
                            color="primary" 
                            variant="contained" 
                            onClick={this.openInvitationModal} 
                            className="pull-right"
                        >
                            Add Venue
                        </Button>
                    </Heading>
                    <Paper style={{ position: "relative" }}>
                        <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                            <Tabs 
                                value={this.state.tabValue} 
                                onChange={this.handleTabChange} 
                                indicatorColor="primary" 
                                textColor="secondary"
                                scrollable
                                scrollButtons="off"
                                classes={{
                                    root: "tabs-root",
                                    indicator: "tabs-indicator"
                                }}
                            >
                                <Tab 
                                    value={0} 
                                    label="Active Venues" 
                                    classes={{ selected: "tab-selected" }} 
                                />
                                <Tab 
                                    value={1} 
                                    label={
                                        <span className={classes.tabBadge}>
                                            Sent Requests
                                            {sentRequestsCount > 0 && (
                                                <Badge 
                                                    badgeContent={sentRequestsCount} 
                                                    color="primary"
                                                    classes={{ badge: classes.badge }}
                                                    style={{ marginLeft: 20 }}
                                                >
                                                    <span />
                                                </Badge>
                                            )}
                                        </span>
                                    } 
                                    classes={{ selected: "tab-selected" }} 
                                />
                                <Tab 
                                    value={2} 
                                    label={
                                        <span className={classes.tabBadge}>
                                            Incoming Requests
                                            {incomingRequestsCount > 0 && (
                                                <Badge 
                                                    badgeContent={incomingRequestsCount} 
                                                    color="secondary"
                                                    classes={{ badge: classes.badgeHighlight }}
                                                    style={{ marginLeft: 20 }}
                                                >
                                                    <span />
                                                </Badge>
                                            )}
                                        </span>
                                    } 
                                    classes={{ selected: "tab-selected" }} 
                                />
                            </Tabs>
                        </AppBar>
                        {this.renderTabComponent()}
                    </Paper>
                </MainContainer>
                <VenueInvitationModal 
                    open={this.state.venueInvitationModalState} 
                    onClose={this.closeInvitationModal} 
                />
            </div>
        );
    }
}

export default withStyles(styles)(AgentVenue);
